export default function getRequestBaseURL() {
  const { host, protocol } = window.location;
  const hostName = host.replace('www.', '');
  if (host.startsWith('localhost')) {
    return 'https://app.alphamon.xyz/api/v2';
  }
  return `${protocol}//app.${hostName}/api/v2`;
}
